<script lang="ts">
	import xss from 'xss';
	import { TextStyle } from './TextStyle';

	let {
		text,
		style = TextStyle.Small
	}: { text: string; style?: TextStyle | keyof typeof TextStyle } = $props();

	const transform: TextStyle =
		typeof style == 'object' ? style : TextStyle[style as keyof typeof TextStyle];

	const protocols = /^(https?|\/|#|tel:|mailto:|\.\.?\/)/;

	const sanitized = xss(text, {
		whiteList: {
			q: [],
			blockquote: ['class'],
			cite: [],
			img: ['src', 'alt', 'title', 'width', 'height', 'loading'],
			figcaption: ['class'],
			figure: [],
			h2: ['class'],
			h3: ['class'],
			h4: ['class'],
			h5: ['class'],
			p: [],
			a: ['target', 'href', 'title', 'name'],
			table: ['width', 'border', 'align', 'valign'],
			tbody: ['align', 'valign'],
			td: ['width', 'rowspan', 'colspan', 'align', 'valign'],
			tfoot: ['align', 'valign'],
			th: ['width', 'rowspan', 'colspan', 'align', 'valign'],
			thead: ['align', 'valign'],
			tr: ['rowspan', 'align', 'valign'],
			col: ['align', 'valign', 'span', 'width'],
			colgroup: ['align', 'valign', 'span', 'width'],
			ol: [],
			ul: [],
			li: [],
			i: [],
			s: [],
			b: [],
			u: [],
			br: []
		},
		onTag: (tag, _, options) => {
			if (transform[tag]) {
				const { tag: newTag, class: newClass } = transform[tag];
				if (options.isClosing) {
					return `</${newTag}>`;
				} else {
					return `<${newTag}${newClass ? ` class="${newClass}"` : ''}>`;
				}
			}
		},
		safeAttrValue: (_, name, value) => {
			value = value.trim();

			if (name === 'class') {
				const classes = value.split(' ');
				const allowedClasses = classes.filter((c) => c.startsWith('text:'));
				value = allowedClasses.join(' ');
			} else if (name === 'href' || name === 'src') {
				if (!protocols.test(value)) return '';
			}

			return value;
		},
		stripIgnoreTag: true,
		stripIgnoreTagBody: ['script'],
		css: false
	});
</script>

<!-- eslint-disable-next-line svelte/no-at-html-tags -->
{@html sanitized}
